import { render } from "./toggleableContent.vue?vue&type=template&id=7a37b870&scoped=true"
import script from "./toggleableContent.vue?vue&type=script&lang=ts"
export * from "./toggleableContent.vue?vue&type=script&lang=ts"

import "./toggleableContent.vue?vue&type=style&index=0&id=7a37b870&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-7a37b870"

export default script